import React from "react";
import Logo from "../../assets/images/logo_marketplace.png";
import AuthService from "../../services/AuthService";
import UserService from "../../services/UserService";
import "../../styles/components/account-access-gate.css";

class AccountAccessGate extends React.Component {
  state = {
    isSubmitting: false,
    error: "",
    success: "",
  };

  onResendVerificationEmail = async () => {
    this.setState({
      isSubmitting: true,
      error: "",
      success: "",
    });

    try {
      const response = await AuthService.resendVerificationEmail();
      this.setState({
        isSubmitting: false,
        success:
          response?.message ||
          "Email di verifica inviata correttamente. Controlla la tua casella di posta.",
      });
    } catch (error) {
      this.setState({
        isSubmitting: false,
        error:
          error?.response?.data?.detail ||
          "Invio email di verifica non riuscito. Riprova tra poco.",
      });
    }
  };

  render() {
    const { profile, isSeller } = this.props;
    const isEmailVerified = Boolean(profile?.emailVerified);
    const isSellerApproved = Boolean(profile?.isSellerApproved);
    const needsVerification = !isEmailVerified;
    const needsSellerApproval = isSeller && isEmailVerified && !isSellerApproved;

    const title = needsVerification
      ? "Verifica la tua email per continuare"
      : "Account venditore in attesa di approvazione";
    const description = needsVerification
      ? `Abbiamo inviato una mail di verifica a ${profile?.email || "questo indirizzo"}. Conferma l'indirizzo email per attivare il tuo account Marketplace.`
      : "Il tuo account venditore è stato creato correttamente, ma deve ancora essere abilitato da un amministratore Marketplace prima di poter operare.";
    const badge = needsVerification ? "Email da verificare" : "In attesa di approvazione";

    return (
      <div className="account-access-gate">
        <div className="account-access-gate__card">
          <span className="account-access-gate__badge">{badge}</span>
          <img src={Logo} alt="Marketplace" className="account-access-gate__logo" />
          <h1>{title}</h1>
          <p>{description}</p>

          {needsSellerApproval ? (
            <div className="account-access-gate__notice">
              Riceverai una conferma appena l'amministratore abiliterà il profilo venditore.
            </div>
          ) : null}

          {this.state.error ? (
            <div className="alert alert-danger account-access-gate__feedback">
              {this.state.error}
            </div>
          ) : null}

          {this.state.success ? (
            <div className="alert alert-success account-access-gate__feedback">
              {this.state.success}
            </div>
          ) : null}

          <div className="account-access-gate__actions">
            {needsVerification ? (
              <button
                type="button"
                className="btn btn-primary account-access-gate__primary"
                onClick={this.onResendVerificationEmail}
                disabled={this.state.isSubmitting}
              >
                {this.state.isSubmitting
                  ? "Invio in corso..."
                  : "Invia di nuovo email di verifica"}
              </button>
            ) : null}

            <button
              type="button"
              className="btn btn-outline-primary account-access-gate__secondary"
              onClick={() => UserService.doLogout()}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountAccessGate;
